/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

export const gtmEventTypes = {
  NO_STOCK_FOR_MODEL: 'NOT-IMPLEMENTED',
  ENTER_LOCATION: 'FED-OL-001',
  SELECT_DEALER_NAME: 'FED-OL-002',
  CLICK_ADDRESS: 'FED-OL-003',
  CLICK_WEBSITE: 'FED-OL-004',
  CLICK_PHONE: 'FED-OL-005',
  EDIT_DEALER: 'FED-OL-006',
  CONFIRM_DEALER: 'FED-OL-007',
  SELECT_NAMEPLATE: 'FED-OL-008',
  CLICK_NO_STOCK_CHANGE: 'FED-OL-009',
  CLICK_NO_STOCK_BUILD: 'FED-OL-010',
  SELECT_STOCK_TILE: 'FED-OL-011',
  CLEARANCE_UNCHECKED: 'FED-OL-012',
  DEMO_UNCHECKED: 'FED-OL-013',
  CLEARANCE_CHECKED: 'FED-OL-014',
  DEMO_CHECKED: 'FED-OL-015',
  EDIT_MODEL: 'FED-OL-016',
  CLICK_INFO: 'FED-OL-017',
  CLICK_SORT_OPTION: 'FED-OL-018',
  CLICK_PRICE_DISCLAIMER: 'FED-OL-019',
  SLIDESHOW_INTERACTION_DETAIL: 'FED-OL-020',
  CLICK_PRICE_DISCLAIMER_DETAIL: 'FED-OL-021',
  EXPAND_ACCORDION_DETAIL: 'FED-OL-022',
  COLLAPSE_ACCORDION_DETAIL: 'FED-OL-023',
  CLICK_FULL_SPECS_DETAIL: 'FED-OL-024',
  CLICK_BACK_DETAIL: 'FED-OL-025',
  CLICK_NEXT_DETAIL: 'FED-OL-026',
}

// Action creators
export const gtmEvents = {
  [gtmEventTypes.NO_STOCK_FOR_MODEL]: ({dealerName, nameplate, buttonText}) => ({
    type: gtmEventTypes.NO_STOCK_FOR_MODEL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.NO_STOCK_FOR_MODEL,
    pageCategory: 'Outlet Store',
    pageAction: `Select Your Model - No Stock Available - ${dealerName.toUpperCase()} - ${nameplate.toUpperCase()} - Clicked - "${buttonText.toUpperCase()}"`,
  }),
  [gtmEventTypes.ENTER_LOCATION]: ({location}) => ({
    type: gtmEventTypes.ENTER_LOCATION,
    event: 'reactjs.event',
    eventID: gtmEventTypes.ENTER_LOCATION,
    pageCategory: 'Outlet Store',
    pageAction: `Select Your Dealer - Entered "${location.toUpperCase()}"`,
  }),
  [gtmEventTypes.SELECT_DEALER_NAME]: ({dealerName}) => ({
    type: gtmEventTypes.SELECT_DEALER_NAME,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_DEALER_NAME,
    pageCategory: 'Outlet Store',
    pageAction: `Select Your Dealer - Selected "${dealerName}"`,
  }),
  [gtmEventTypes.CLICK_ADDRESS]: ({dealerName, address}) => ({
    type: gtmEventTypes.CLICK_ADDRESS,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_ADDRESS,
    pageCategory: 'Outlet Store',
    pageAction: `Select Your Dealer - ${dealerName} - Clicked "ADDRESS ${address.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICK_WEBSITE]: ({dealerName, website}) => ({
    type: gtmEventTypes.CLICK_WEBSITE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_WEBSITE,
    pageCategory: 'Outlet Store',
    pageAction: `Select Your Dealer - ${dealerName} - Clicked "WEBSITE ${website.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICK_PHONE]: ({dealerName, phone}) => ({
    type: gtmEventTypes.CLICK_PHONE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_PHONE,
    pageCategory: 'Outlet Store',
    pageAction: `Select Your Dealer - ${dealerName} - Clicked "PHONE ${phone}"`,
  }),
  [gtmEventTypes.ENTER_LOCATION]: ({location}) => ({
    type: gtmEventTypes.ENTER_LOCATION,
    event: 'reactjs.event',
    eventID: gtmEventTypes.ENTER_LOCATION,
    pageCategory: 'Outlet Store',
    pageAction: `Select Your Dealer - Entered "${location.toUpperCase()}"`,
  }),
  [gtmEventTypes.EDIT_DEALER]: ({buttonText, dealerName}) => ({
    type: gtmEventTypes.EDIT_DEALER,
    event: 'reactjs.event',
    eventID: gtmEventTypes.EDIT_DEALER,
    pageCategory: 'Outlet Store',
    pageAction: `Footer Nav - Clicked "${buttonText.toUpperCase()}" - "${dealerName.toUpperCase()}"`,
  }),
  [gtmEventTypes.CONFIRM_DEALER]: ({buttonText, dealerAddress}) => ({
    type: gtmEventTypes.CONFIRM_DEALER,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CONFIRM_DEALER,
    pageCategory: 'Outlet Store',
    pageAction: `Select Your Dealer - Clicked "${buttonText.toUpperCase()}" - ${dealerAddress.toUpperCase()}`,
  }),
  [gtmEventTypes.SELECT_NAMEPLATE]: ({nameplate, dealerName}) => ({
    type: gtmEventTypes.SELECT_NAMEPLATE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_NAMEPLATE,
    pageCategory: 'Outlet Store',
    pageAction: `Select Your Model - Selected "${nameplate.toUpperCase()}" - "${dealerName.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICK_NO_STOCK_CHANGE]: ({buttonText, dealerName}) => ({
    type: gtmEventTypes.CLICK_NO_STOCK_CHANGE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_NO_STOCK_CHANGE,
    pageCategory: 'Outlet Store',
    pageAction: `Select Your Model - No Stock Available - ${dealerName.toUpperCase()} - Clicked "${buttonText.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICK_NO_STOCK_BUILD]: ({buttonText, nameplate, dealerName}) => ({
    type: gtmEventTypes.CLICK_NO_STOCK_BUILD,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_NO_STOCK_BUILD,
    pageCategory: 'Outlet Store',
    pageAction: `Select Your Model - No Stock Available - ${dealerName.toUpperCase()} - ${nameplate.toUpperCase()} - Clicked "${buttonText.toUpperCase()}"`,
  }),
  [gtmEventTypes.SELECT_STOCK_TILE]: ({
                                        storeTypeCategory,
                                        nameplate,
                                        bodyStyle,
                                        grade,
                                        engineSize,
                                        transmissionType,
                                        fuelType,
                                        fittedAccessories,
                                        price,
                                        odometer,
                                        generation,
                                        interiorTitle,
                                        dealerName,
                                      }) => ({
    type: gtmEventTypes.SELECT_STOCK_TILE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_STOCK_TILE,
    pageCategory: 'Outlet Store',
    pageAction: `Search Result - Selected "${storeTypeCategory.toUpperCase()}" - ${[
      nameplate,
      bodyStyle,
      grade,
      engineSize,
      transmissionType,
      fuelType,
      fittedAccessories,
      `$${price.toLocaleString('au')}`,
      odometer,
      generation,
      interiorTitle,
    ]
      .map(string => `"${String(string).toUpperCase()}"`)
      .join(',')} - "${dealerName.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLEARANCE_UNCHECKED]: ({label}) => ({
    type: gtmEventTypes.CLEARANCE_UNCHECKED,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLEARANCE_UNCHECKED,
    pageCategory: 'Outlet Store',
    pageAction: `Search Result - Unchecked "${label.toUpperCase()}"`,
  }),
  [gtmEventTypes.DEMO_UNCHECKED]: ({label}) => ({
    type: gtmEventTypes.DEMO_UNCHECKED,
    event: 'reactjs.event',
    eventID: gtmEventTypes.DEMO_UNCHECKED,
    pageCategory: 'Outlet Store',
    pageAction: `Search Result - Unchecked "${label.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLEARANCE_CHECKED]: ({label}) => ({
    type: gtmEventTypes.CLEARANCE_CHECKED,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLEARANCE_CHECKED,
    pageCategory: 'Outlet Store',
    pageAction: `Search Result - Checked "${label.toUpperCase()}"`,
  }),
  [gtmEventTypes.DEMO_CHECKED]: ({label}) => ({
    type: gtmEventTypes.DEMO_CHECKED,
    event: 'reactjs.event',
    eventID: gtmEventTypes.DEMO_CHECKED,
    pageCategory: 'Outlet Store',
    pageAction: `Search Result - Checked "${label.toUpperCase()}"`,
  }),
  [gtmEventTypes.EDIT_MODEL]: ({buttonText, nameplate}) => ({
    type: gtmEventTypes.EDIT_MODEL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.EDIT_MODEL,
    pageCategory: 'Outlet Store',
    pageAction: `Footer Nav - Clicked "${buttonText.toUpperCase()}" - "${nameplate.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICK_INFO]: ({buttonText}) => ({
    type: gtmEventTypes.CLICK_INFO,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_INFO,
    pageCategory: 'Outlet Store',
    pageAction: `Footer Nav - Clicked "${buttonText.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICK_SORT_OPTION]: ({label}) => ({
    type: gtmEventTypes.CLICK_SORT_OPTION,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_SORT_OPTION,
    pageCategory: 'Outlet Store',
    pageAction: `Search Result - Sort Results Dropdown - Selected "${label.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICK_PRICE_DISCLAIMER]: ({nameplate, storeTypeCategory, grade}) => ({
    type: gtmEventTypes.CLICK_PRICE_DISCLAIMER,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_PRICE_DISCLAIMER,
    pageCategory: 'Outlet Store',
    pageAction: `Search Result - "${nameplate.toUpperCase()}", "${storeTypeCategory.toUpperCase()}" "${grade.toUpperCase()}" - Clicked "PRICE DISCLAIMER"`,
  }),
  [gtmEventTypes.SLIDESHOW_INTERACTION_DETAIL]: ({
                                                   nameplate,
                                                   bodyStyle,
                                                   storeTypeCategory,
                                                   grade,
                                                   imageLabel,
                                                 }) => ({
    type: gtmEventTypes.SLIDESHOW_INTERACTION_DETAIL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SLIDESHOW_INTERACTION_DETAIL,
    pageCategory: 'Outlet Store',
    pageAction: `Vehicle Details Page - "${nameplate.toUpperCase()} ${bodyStyle.toUpperCase()}", "${storeTypeCategory.toUpperCase()}", "${grade.toUpperCase()}" - Engaged Carousel "${imageLabel.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICK_PRICE_DISCLAIMER_DETAIL]: ({
                                                    nameplate,
                                                    bodyStyle,
                                                    storeTypeCategory,
                                                    grade,
                                                  }) => ({
    type: gtmEventTypes.CLICK_PRICE_DISCLAIMER_DETAIL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_PRICE_DISCLAIMER_DETAIL,
    pageCategory: 'Outlet Store',
    pageAction: `Vehicle Details Page - "${nameplate.toUpperCase()} ${bodyStyle.toUpperCase()}", "${storeTypeCategory.toUpperCase()}", "${grade.toUpperCase()}" - Clicked "PRICE DISCLAIMER"`,
  }),
  [gtmEventTypes.EXPAND_ACCORDION_DETAIL]: ({
                                              nameplate,
                                              bodyStyle,
                                              storeTypeCategory,
                                              grade,
                                              sectionTitle,
                                            }) => ({
    type: gtmEventTypes.EXPAND_ACCORDION_DETAIL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.EXPAND_ACCORDION_DETAIL,
    pageCategory: 'Outlet Store',
    pageAction: `Vehicle Details Page - "${nameplate.toUpperCase()} ${bodyStyle.toUpperCase()}", "${storeTypeCategory.toUpperCase()}", "${grade.toUpperCase()}" - Expanded "${sectionTitle.toUpperCase()}"`,
  }),
  [gtmEventTypes.COLLAPSE_ACCORDION_DETAIL]: ({
                                                nameplate,
                                                bodyStyle,
                                                storeTypeCategory,
                                                grade,
                                                sectionTitle,
                                              }) => ({
    type: gtmEventTypes.COLLAPSE_ACCORDION_DETAIL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.COLLAPSE_ACCORDION_DETAIL,
    pageCategory: 'Outlet Store',
    pageAction: `Vehicle Details Page - "${nameplate.toUpperCase()} ${bodyStyle.toUpperCase()}", "${storeTypeCategory.toUpperCase()}", "${grade.toUpperCase()}" - Collapsed "${sectionTitle.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICK_FULL_SPECS_DETAIL]: ({
                                              nameplate,
                                              bodyStyle,
                                              storeTypeCategory,
                                              grade,
                                              buttonText,
                                            }) => ({
    type: gtmEventTypes.CLICK_FULL_SPECS_DETAIL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_FULL_SPECS_DETAIL,
    pageCategory: 'Outlet Store',
    pageAction: `Vehicle Details Page - "${nameplate.toUpperCase()} ${bodyStyle.toUpperCase()}" "${storeTypeCategory.toUpperCase()}", "${grade.toUpperCase()}" - Clicked ${buttonText.toUpperCase()}`,
  }),
  [gtmEventTypes.CLICK_BACK_DETAIL]: ({buttonText}) => ({
    type: gtmEventTypes.CLICK_BACK_DETAIL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_BACK_DETAIL,
    pageCategory: 'Outlet Store',
    pageAction: `Vehicle Details Page - Footer Nav - Clicked "${buttonText.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICK_NEXT_DETAIL]: ({
                                        nameplate,
                                        bodyStyle,
                                        storeTypeCategory,
                                        grade,
                                        hasAccessories,
                                        fittedAccessories,
                                        dealerName,
                                        buttonText,
                                      }) => ({
    type: gtmEventTypes.CLICK_NEXT_DETAIL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_NEXT_DETAIL,
    pageCategory: 'Outlet Store',
    pageAction: `Vehicle Details Page - Footer Nav - Clicked "${buttonText.toUpperCase()}" - "${storeTypeCategory.toUpperCase()}", "${nameplate.toUpperCase()} ${bodyStyle.toUpperCase()}", "${grade.toUpperCase()}", ACCESSORIES "${hasAccessories.toUpperCase()}", "${fittedAccessories.toUpperCase()}" - ${dealerName.toUpperCase()}"`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/outlet-store-duck.js